// "ส่งในนามของ": choose whose saved eMemo login the forms are submitted with. People
// save their own login on the profile page; the last pick is remembered.
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../../config/api';

const EmemoPicker = ({ onChange }) => {
  const [accounts, setAccounts] = useState([]);
  const [selected, setSelected] = useState('');
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/ememo/accounts`)
      .then(resp => {
        const list = resp.data.accounts || [];
        setAccounts(list);
        setSelected(resp.data.selected ? String(resp.data.selected) : '');
        if (onChange && resp.data.selected) {
          const hit = list.find(a => a.id === resp.data.selected);
          onChange(resp.data.selected, hit ? hit.display_name : '');
        }
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const choose = async (value) => {
    const previous = selected;
    setSelected(value);
    if (onChange) onChange(value ? Number(value) : null, accounts.find(a => String(a.id) === String(value))?.display_name || '');
    try {
      await axios.put(`${API_URL}/ememo/choice`, { account_id: value ? Number(value) : null });
    } catch (err) {
      setSelected(previous);
      if (onChange) onChange(previous ? Number(previous) : null, accounts.find(a => String(a.id) === String(previous))?.display_name || '');
      toast.error(err.response?.data?.message || 'บันทึกการเลือกไม่สำเร็จ');
    }
  };

  return (
    <div className="rs-field" style={{ maxWidth: 420, marginBottom: 14 }}>
      <label htmlFor="ememo_pick">ส่งเอกสารในนามของ (eMemo)</label>
      <select id="ememo_pick" className="rs-input" value={selected} disabled={!loaded} onChange={(e) => choose(e.target.value)}>
        <option value="">— เลือกผู้ส่ง —</option>
        {accounts.map(a => <option key={a.id} value={a.id}>{a.display_name} ({a.ememo_username})</option>)}
      </select>
      {loaded && accounts.length === 0 && (
        <span className="rs-help rs-help--warn">ยังไม่มีใครบันทึกบัญชี eMemo ไว้ ให้ผู้ส่งไปกรอกที่หน้าโปรไฟล์ก่อน</span>
      )}
    </div>
  );
};

export default EmemoPicker;
